import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "iframe", "loading"]
  
  connect() {
    document.addEventListener("keydown", this.handleKeyDown)
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.handleKeyDown)
  }
  
  handleKeyDown = (e) => {
    if (e.key === "Escape") {
      this.close()
    }
  }
  
  open(event) {
    // Prevent event bubbling to avoid dropdown interference
    event.preventDefault()
    event.stopPropagation()
    
    const secondCopyUrl = event.currentTarget.dataset.secondCopyUrl
    
    // Small delay to ensure dropdown events are processed first
    setTimeout(() => {
      this.modalTarget.classList.remove("hidden")
      document.body.style.overflow = "hidden"
      
      this.loadingTarget.classList.remove("hidden")
      this.iframeTarget.classList.add("hidden")
      
      this.iframeTarget.onload = () => {
        this.loadingTarget.classList.add("hidden")
        this.iframeTarget.classList.remove("hidden")
      }
      
      this.iframeTarget.src = secondCopyUrl
    }, 100)
  }
  
  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.iframeTarget.src = ""
  }
  
  openInNewTab() {
    if (this.iframeTarget.src) {
      window.open(this.iframeTarget.src, '_blank')
    }
  }
}